import { useState, useCallback } from 'react';
import { compressImage } from '../utils/compressImage';

export const useImageCompression = () => {
  const [isCompressing, setIsCompressing] = useState(false);

  const compressMultipleImages = useCallback(async (files: File[]): Promise<File[]> => {
    setIsCompressing(true);
    try {
      const compressedFiles = await Promise.all(
        files.map(async (file) => {
          if (file.type.startsWith('image/')) {
            return await compressImage(file);
          }
          return file;
        })
      );
      return compressedFiles;
    } finally {
      setIsCompressing(false);
    }
  }, []);

  const compressSingleImage = useCallback(async (file: File): Promise<File> => {
    setIsCompressing(true);
    try {
      if (file.type.startsWith('image/')) {
        return await compressImage(file);
      }
      return file;
    } finally {
      setIsCompressing(false);
    }
  }, []);

  return {
    compressSingleImage,
    compressMultipleImages,
    isCompressing,
  };
};